<div class="thought-trail">
    <div class="trail-head-row">
        <ng-content></ng-content>
        <span
            class="trail-header"
            role="button"
            tabindex="0"
            [attr.aria-expanded]="!collapsed"
            (click)="onToggle()"
            (keydown.enter)="onToggle()"
            (keydown.space)="$event.preventDefault(); onToggle()">
            <span class="header-label">
                <ng-container *ngIf="streaming">Thinking…</ng-container>
                <ng-container *ngIf="!streaming">
                    <ng-container *ngIf="elapsedSeconds !== null; else processFallback">
                        Thought for {{ elapsedSeconds }}s
                    </ng-container>
                    <ng-template #processFallback>Thought process</ng-template>
                </ng-container>
            </span>
            <i
                class="ph-bold trail-caret"
                [class.ph-caret-down]="!collapsed"
                [class.ph-caret-up]="collapsed"
                aria-hidden="true"></i>
        </span>
    </div>

    <!--
        Rendered body: groups consecutive summary thoughts into prose blocks
        and renders tool calls as discrete status rows. Matches the
        Claude.ai "Thought process" look — one calm column of reasoning,
        with action rows interspersed when the model uses a tool.
    -->
    <div class="trail-body" *ngIf="!collapsed && groups.length > 0">
        <ng-container *ngFor="let group of groups; trackBy: trackByGroup">
            <!-- Summary prose block: multiple summary thoughts collapse into
                 one paragraph stack with comfortable spacing. -->
            <div *ngIf="group.kind === 'summaries'" class="thought-prose">
                <p
                    *ngFor="let s of group.items; trackBy: trackById"
                    class="prose-line">
                    {{ s.label }}
                </p>
            </div>

            <!-- Tool-call row: quiet gray-italic text, same voice as the
                 prose lines. The spinner only shows while the call is
                 in-flight (ok undefined) — once resolved the row is just
                 text, no status icon. -->
            <div *ngIf="group.kind === 'tool'" class="thought-tool-row">
                <i
                    *ngIf="group.tool.ok === undefined"
                    class="ph-bold ph-circle-notch row-icon icon-placeholder icon-16 spinning"
                    aria-hidden="true"></i>
                <span class="tool-label">{{ group.tool.label }}</span>
                <span *ngIf="group.repeatCount > 1" class="tool-repeat">× {{ group.repeatCount }}</span>
            </div>
        </ng-container>
    </div>
</div>
